An opaque cursor to the later bounding webhook attempt.

Resulting webhook attempts will _precede_ this cursor.
